import React, {Component} from 'react';
import PropTypes from 'prop-types';
// constants
import {imageUrl} from '~/utils/productImage';
// components
import SelectorList from '~/shared/components/SelectorList';
import {Typography} from '@customink/pigment-react';

import './ImageViewer.scss';

const propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  onSelectionChange: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class ImageViewer extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    images: [],
    onSelectionChange() {}
  };

  state = {
    selectedIndex: 0,
    useImgix: true
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.images[this.state.selectedIndex]) {
      this.setState({selectedIndex: 0});
    }
  }

  handleChange = (_, index) => this.setState({selectedIndex: index});

  handleError = () => {
    // Try fetching image from mms-images.out.customink.com/mms
    // in case IMGIX are having problems on their side
    if (this.state.useImgix) {
      this.setState({useImgix: false});
    }
  };

  renderPreview = (image, index) => (
    <img
      alt={`Supporting image of product ${index + 1}`}
      className="ndx-ProductCarousel-image"
      height={80}
      src={imageUrl(image, this.state.useImgix, {h: 80})}
      onError={this.handleError}
    />
  );

  render() {
    const {selectedIndex: index, useImgix} = this.state;
    const {images, title} = this.props;

    return (
      !!images.length && (
        <div className="ndx-ProductCarousel">
          <div className="ndx-ProductCarousel-mainImage">
            <img
              alt={`Supporting image of product ${index + 1}`}
              className="ndx-ProductCarousel-image"
              src={imageUrl(images[index], useImgix, {w: 350})}
              width={350}
              onError={this.handleError}
            />
          </div>
          {title && <Typography variant="heading5">{title}</Typography>}
          <SelectorList
            options={images}
            renderOption={this.renderPreview}
            selectedIndex={index}
            showArrows="always"
            onChange={this.handleChange}
          />
        </div>
      )
    );
  }
}
